import { render, staticRenderFns } from "./SelectorArtist.vue?vue&type=template&id=afe96e0c&scoped=true&"
import script from "./SelectorArtist.vue?vue&type=script&lang=js&"
export * from "./SelectorArtist.vue?vue&type=script&lang=js&"
import style0 from "./SelectorArtist.vue?vue&type=style&index=0&id=afe96e0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe96e0c",
  null
  
)

export default component.exports